@if (contractorMissing) {
  <wr-banner status="warning"
             [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
             message="Die Arbeitspakete sind nur für angemeldete Dienstleister sichtbar."></wr-banner>
} @else {
  <wr-list-view [items]="repairTasks">
    <ng-template wrListItem let-item>
      <wr-repair-task-item [showDeleteButton]="false"
                           [showConfirmButton]="true"
                           [repairTask]="item"
                           [showDescription]="true"
                           (repairTaskFinished)="loadRepairTasks()"></wr-repair-task-item>
    </ng-template>
  </wr-list-view>
}
